<template>
    <base-table-row :class="engagement.is_paused ? 'bg-yellow-50' : ''">
        <base-table-cell>
            <div class="flex items-center space-x-1 whitespace-nowrap">
                <div @click="showForm" class="text-accent-primary hover:text-dark-primary hover:cursor-pointer hover:underline">
                    {{ engagement.id }}
                </div>
                <span v-if="engagement.is_paused"
                      class="px-1.5 py-0.5 rounded bg-yellow-200 text-yellow-900 text-[10px] font-semibold uppercase tracking-wide"
                      :title="engagement.current_pause_reason || 'On hold — reason not recorded'">
                    On Hold
                </span>
            </div>
            <base-modal :is-form-visible="formVisible" @close="closeForm">
                <template #header>
                    <h2 class="text-lg">
                    Edit Engagement ID: {{ engagement.id }}
                    </h2>
                </template>
                <template #body>
                    <EngagementForm
                        :engagement="engagement"
                        :clients="clients"
                        @submit-form="editEngagement"
                        @cancel="closeForm"
                        @pause-changed="onPauseChanged"
                    />
                </template>
            </base-modal>
        </base-table-cell>
        <base-table-cell>
            <div class="min-w-[10rem]">{{ clientName }}</div>
        </base-table-cell>
        <base-table-cell>
            <div class="whitespace-nowrap">
                <EngagementStartDateCell :engagement="engagement" @refetch-engagements="fetchNewEngagements" />
            </div>
        </base-table-cell>
        <base-table-cell>
            <div class=" whitespace-nowrap">
                <EngagementEndDateCell :engagement="engagement" @refetch-engagements="fetchNewEngagements" />
            </div>
        </base-table-cell>
        <!-- <base-table-cell>
            <div class=" whitespace-nowrap">
                <EngagementCompensationTypeCell :engagement="engagement" @refetch-engagements="fetchNewEngagements" />
            </div>
        </base-table-cell> -->
        <base-table-cell>
            <div class="whitespace-nowrap flex justify-end">
                <EngagementRetainerAmountCell :engagement="engagement" @refetch-engagements="fetchNewEngagements" />
            </div>
        </base-table-cell>
        <base-table-cell>
            <EngagementBillingTimeframeCell :engagement="engagement" @refetch-engagements="fetchNewEngagements" />
        </base-table-cell>
        <base-table-cell>
            <EngagementInvoiceDueDeltaCell :engagement="engagement" @refetch-engagements="fetchNewEngagements" />                    
        </base-table-cell>
        <base-table-cell>
            <div class="min-w-[9rem]">
                <EngagementTargetInvoiceDayCell :engagement="engagement"/>
            </div>
        </base-table-cell>
        <base-table-cell>
            <EngagementDaysUntilTargetInvoiceDayCell :engagement="engagement"/>
            <div v-if="engagement.invoice_instructions" class="text-center mt-0.5">
                <div class="relative inline-block">
                    <span @click.stop="showInstructions = !showInstructions"
                          :title="engagement.invoice_instructions"
                          class="inline-block px-1 py-0.5 rounded bg-indigo-100 text-indigo-800 hover:bg-indigo-200 text-[8px] font-semibold uppercase tracking-wide cursor-pointer">
                        Special Instructions
                    </span>
                    <div v-if="showInstructions" v-click-outside="() => showInstructions = false"
                         class="absolute z-20 left-1/2 -translate-x-1/2 mt-1 w-64 p-2 bg-white border border-indigo-300 rounded shadow-lg text-left text-xs font-normal normal-case tracking-normal text-gray-800 whitespace-pre-wrap break-words">
                        {{ engagement.invoice_instructions }}
                    </div>
                </div>
            </div>
            <div v-if="futureTerminationLabel" class="text-center mt-0.5">
                <span class="inline-block px-1 py-0.5 rounded bg-rose-100 text-rose-800 text-[8px] font-semibold uppercase tracking-wide"
                      :title="`Engagement is scheduled to terminate on ${futureTerminationLabel}`">
                    Termination - {{ futureTerminationLabel }}
                </span>
            </div>
        </base-table-cell>
        <base-table-cell>
        <EngagementTargetDueDateCell :engagement="engagement" @refetch-engagements="fetchNewEngagements" />                    
        </base-table-cell>
        <base-table-cell>
            <div class="min-w-[12rem]">
                <EngagementMostRecentInvoiceCell :engagement="engagement"/>
            </div>
        </base-table-cell>
        <!-- <base-table-cell>
            <EngagementMissingInvoiceCell :engagement="engagement"/>
        </base-table-cell> -->
        <!-- <base-table-cell>
            <EngagementMostRecentInvoiceDueDateCell :engagement="engagement"/>
        </base-table-cell> -->
        <base-table-cell>
            <div class="text-center">
                <a
                    @click="statementVisible = true"
                    class="inline-flex flex-col items-center text-accent-primary hover:text-dark-primary cursor-pointer leading-tight"
                >
                    <span class="font-semibold underline">{{ overdueCount }}</span>
                    <span class="text-[10px] uppercase tracking-wide">View statement</span>
                </a>
            </div>
            <ClientStatementModal
                :is-visible="statementVisible"
                :client-id="engagement.client?.id || null"
                @close="statementVisible = false"
            />
        </base-table-cell>
        <base-table-cell>
            <EngagementAccountingPostsCell :engagement="engagement" @refetch-engagements="fetchNewEngagements"/>
            <!-- <div class="flex flex-col space-y-1 p-1" v-if="allAccountingPostsVisible">
                <div class="flex flex-col" v-for="(post, idx) in engagement.accounting_posts" :key="post.id">
                    <div class="flex w-max">
                        {{ new Date(post.created_at).toLocaleDateString() }}: {{ post.post_body }}
                    </div>
                    <div class="w-full border-b border-b-black" v-if="idx < engagement.accounting_posts.length - 1"></div>
                </div>
                <div>
                   <button v-if="engagement.accounting_posts.length > 0" class="text-xs border border-dark-primary px-0.5 rounded-full h-fit hover:text-white hover:bg-dark-primary" @click="setAccountingPostsVisibility(false)">-</button>
                </div>
            </div>
            <div v-else-if="engagement.accounting_posts.length > 0">
                <div class="flex w-max" >
                        {{ new Date(engagement.accounting_posts[0].created_at).toLocaleDateString() }}: {{ engagement.accounting_posts[0].post_body }} 
                </div>
                <div>
                    <button class="text-xs border border-dark-primary px-0.5 rounded-full h-fit hover:text-white hover:bg-dark-primary" @click="setAccountingPostsVisibility(true)">+</button>
                </div>
            </div> -->
        </base-table-cell>
    </base-table-row>

</template>

<script>
export default {
    name: 'engagement-row'
}
</script>

<script setup>
import { ref, defineProps, defineEmits, computed, watch } from 'vue';
import EngagementStartDateCell from './EngagementStartDateCell.vue';
import EngagementEndDateCell from './EngagementEndDateCell.vue';
import EngagementCompensationTypeCell from './EngagementCompensationTypeCell.vue';
import EngagementRetainerAmountCell from './EngagementRetainerAmountCell.vue';
import EngagementPaymentTermsCell from './EngagementPaymentTermsCell.vue';
import EngagementBillingTimeframeCell from './EngagementBillingTimeframeCell.vue';
import EngagementTargetInvoiceDateCell from './EngagementTargetInvoiceDateCell.vue';
import EngagementInvoiceDueDeltaCell from './EngagementInvoiceDueDeltaCell.vue';
import EngagementTargetDueDateCell from './EngagementTargetDueDateCell.vue';
import EngagementTypicalPaydayCell from './EngagementTypicalPaydayCell.vue';
import EngagementMostRecentInvoiceCell from './EngagementMostRecentInvoiceCell.vue';
import EngagementMostRecentInvoiceDueDateCell from './EngagementMostRecentInvoiceDueDateCell.vue';
import EngagementTargetInvoiceDayCell from './EngagementTargetInvoiceDayCell.vue';
import EngagementAccountingPostsCell from './EngagementAccountingPostsCell.vue';
import EngagementMissingInvoiceCell from './EngagementMissingInvoiceCell.vue';
import EngagementDaysUntilTargetInvoiceDayCell from './EngagementDaysUntilTargetInvoiceDayCell.vue'
import EngagementForm from './EngagementForm.vue';
import ClientStatementModal from '../invoice_components/ClientStatementModal.vue';
import { updateEngagement } from '@/services/Engagement';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';

const props = defineProps([
    'engagement',
    'clients',
    'client'
])

const store = useStore()
const $toast = useToast()

const emit = defineEmits(['refetch-engagements'])

const showInstructions = ref(false)

const clientName = computed(() => {
    if(props.client){
        return props.client.client_name
    } else {
        return props.engagement.client.client_name
    }
})

function fetchNewEngagements() {
    emit('refetch-engagements')
}

// Show a "Termination - MM-DD-YYYY" flag when the engagement's end date
// (its termination date) is set and still in the future, so accounting sees
// an upcoming wind-down at a glance. String compare/format avoids timezone
// drift from parsing the ISO date into a Date.
const futureTerminationLabel = computed(() => {
    const end = props.engagement.end_date
    if (!end) return ''
    const today = new Date()
    const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
    if (end <= todayStr) return ''
    const [y, m, d] = end.split('-')
    return `${m}-${d}-${y}`
})

const overdueCount = computed(() => {
    const today = new Date()
    const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
    const excludedStatuses = ['Paid', 'Void', 'Draft', 'Write Off']
    return (props.engagement.invoices || []).filter((inv) => {
        if (!inv.sent_date) return false
        if (excludedStatuses.includes(inv.status)) return false
        if (!inv.due_date) return false
        if (inv.due_date >= todayStr) return false
        const balance = Number(inv.invoice_amount || 0) - Number(inv.amount_paid || 0)
        return balance > 0
    }).length
})

const itemsVisible = ref(true)
const allAccountingPostsVisible = ref(true)

const formVisible = ref(false)
const statementVisible = ref(false)

function showForm(){
    formVisible.value = true
}

function closeForm(){
    formVisible.value = false
}

function onPauseChanged() {
    emit('refetch-engagements')
}

function toggleItemVisibility() {
    itemsVisible.value = !itemsVisible.value
}
function setAccountingPostsVisibility(value) {
    allAccountingPostsVisible.value = value
}

async function editEngagement(formData){
    const token = store.state.auth.token
    const response = await updateEngagement(props.engagement.id, formData, token)
    if(response.status === 200){
        $toast.open({
            message: `Successfully updated Engagement ${props.engagement.id}`,
            type: 'success',
            duration: 3000
        })
        formVisible.value = false
        emit('refetch-engagements')
    } else {
        $toast.open({
            message: `Error, could not update Engagement ${props.engagement.id}`,
            type: 'error',
            duration: 3000
        })
    }
}


const accountingPostsText = computed(() => {
    if(allAccountingPostsVisible.value){
        return "-"
    } else {
        return "+"
    }
})

</script>
